import TableSimple from "ds/components/TableSimple";
import useAnalytics from "hooks/useAnalytics";
import { ManagedUserGroupIntegration } from "types/generated";

import ManageSlackAccessEmpty from "../Empty";
import { SLACK_TABLE_CELLS } from "./Cells";
import { SLACK_TABLE_FILTERS_STORAGE_KEY, SORT_CONFIG } from "./constants";
import useSlackTableStore from "./tableStore";

type SlackTableProps = {
  integrations: ManagedUserGroupIntegration[];
  loadingContent?: boolean;
};

const SlackTable = ({ integrations, loadingContent }: SlackTableProps) => {
  const trackAnalytics = useAnalytics();

  return (
    <TableSimple
      data={integrations}
      loading={loadingContent}
      store={useSlackTableStore}
      ariaLabel="Slack integrations table"
      trackAnalytics={trackAnalytics}
      cellPerColumn={SLACK_TABLE_CELLS}
      filtersStorageKey={SLACK_TABLE_FILTERS_STORAGE_KEY}
      sortConfig={SORT_CONFIG}
      virtualize={true}
      emptyState={<ManageSlackAccessEmpty />}
    />
  );
};

export default SlackTable;
